export const SAT_SET_CATALOG = "SAT_SET_CATALOG";
export const SAT_SET_LOAD_ERROR = "SAT_SET_LOAD_ERROR";
export const SAT_CATALOG_REQUESTED = "SAT_CATALOG_REQUESTED";
export const SAT_SET_ATTEMPT_STARTING = "SAT_SET_ATTEMPT_STARTING";
export const SAT_MARK_LESSON_COMPLETE = "SAT_MARK_LESSON_COMPLETE";
